export default __webpack_public_path__ + "static/media/phone.a4b391f3.svg";